<template>
  <GenericWrapperChart :config="config" />
</template>

<script>
import { generateFileName } from '@/utils';

import { GenericWrapperChart } from '@/components/content/GenericWrapperChart';

export default {
  name: 'TotalPublications',
  components: {
    GenericWrapperChart,
  },
  data() {
    return {
      title: 'Total de publicações',
    };
  },
  computed: {
    overrideChartOptions() {
      const filename = generateFileName(this.title);

      return {
        exporting: {
          enabled: false,
          sourceWidth: 750,
          filename,
          chartOptions: {
            title: {
              text: this.title,
            },
          },
        },
      };
    },
    config() {
      const isLoading = this.$store.state.charts.totalPublication.isLoading;
      const title = !isLoading ? this.title : '';
      const description = !isLoading ? 'Total de publicações no período selecionado.' : '';
      const series = this.$store.state.charts.totalPublication.data.series;
      const hasError = this.$store.state.charts.totalPublication.hasError;
      const isEmpty = series.length === 0 && !isLoading && !hasError;

      return {
        componentName: 'TotalPublications',
        title,
        description,
        isLoading,
        hasError,
        isEmpty,
        onError: this.getTotalPublicationsData,
        requestOnMounted: this.getTotalPublicationsData,
        downloadMenu: {
          trackNameOnOpen: 'BM ExportPostChart Graph Open',
          trackNameOnDownload: 'BM ExportPostChart Graph Click',
        },
        chart: {
          type: 'BasicBar',
          series,
          categories: this.$store.state.charts.totalPublication.data.categories,
          overrideChartOptions: this.overrideChartOptions,
          trackNameOnObserve: 'BM PostChart Graph View',
          trackNameOnLegendClick: 'BM MidiaPostAll LegendGraph Click',
        },
      };
    },
  },
  methods: {
    async getTotalPublicationsData() {
      await this.$store.dispatch('charts/fetchTotalPublications');
    },
  },
};
</script>
